import { render, staticRenderFns } from "./perEchart.vue?vue&type=template&id=0f7a8eae&scoped=true&"
import script from "./perEchart.vue?vue&type=script&lang=js&"
export * from "./perEchart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7a8eae",
  null
  
)

export default component.exports